import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  InputAdornment,
  IconButton,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useForm, Controller } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import AtithiLogo from '.././../././../assets/Atithiseva-Logo-Final-1024x298.png';
import TextInputField from '../../../component/ui/FormFields/TextInputField';
import '../../../styles/ResetPassword.css';
import {
  FORGOT_PASSWORD,
  LOGIN,
} from '../../../component/common/Routes/AppRoutes';
import { useDispatch, useSelector } from 'react-redux';
import { resetPasswordRequest } from '../actions/authActions';
import { RESET_PASSWORD_REQUEST } from '../types/AuthTypes';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomButton from '../../../component/ui/FormFields/Button';

export default function ResetPassword() {
  const { control, handleSubmit, setError, watch } = useForm({
    defaultValues: {
      newPassword: '',
      confirmPassword: '',
    },
  });
  const success = useSelector((state) => state.resetPassword?.success);
  const loading = useSelector((state) => state.resetPassword?.loading);

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const email = location.state?.email;
  useEffect(() => {
    dispatch(resetPasswordRequest());
  }, []);
  useEffect(() => {
    if (!email) {
      navigate(FORGOT_PASSWORD);
    }
  }, [email, navigate]);
  useEffect(() => {
    if (success) {
      toast.success('Password changed successfully', {
        position: 'top-center',
        autoClose: 3000,
        onClose: () => {
          dispatch(resetPasswordRequest());
          navigate(LOGIN);
        },
      });
    }
  }, [success]);

  const onSubmit = (data) => {
    const { newPassword, confirmPassword } = data;

    if (newPassword !== confirmPassword) {
      setError('confirmPassword', {
        type: 'manual',
        message: 'Passwords do not match',
      });

      return;
    } else {
      dispatch({
        type: RESET_PASSWORD_REQUEST,
        payload: { email, newPassword },
      });
    }
  };

  return (
    <>
      <ToastContainer position='top-center' />
      <Box className='reset-container'>
        <Box className='lock-icon-bg'>
          <LockIcon />
        </Box>

        <Card className='reset-card'>
          <CardContent>
            <Box textAlign={'center'}>
              <img src={AtithiLogo} alt='Atithiseva Logo' />
            </Box>
            <Box className='reset-title'>
              <Typography variant='h6'>Change Your Password</Typography>
              <Typography variant='body2'>
                Enter your new password and confirm it.
              </Typography>
            </Box>

            <form onSubmit={handleSubmit(onSubmit)}>
              <Controller
                name='newPassword'
                control={control}
                rules={{
                  required: 'New password is required',
                  minLength: {
                    value: 6,
                    message: 'Password must be at least 6 characters',
                  },
                }}
                render={({ field, fieldState }) => (
                  <TextInputField
                    {...field}
                    label='New Password'
                    placeholder='Enter new password'
                    type={showNewPassword ? 'text' : 'password'}
                    className='text-field'
                    error={!!fieldState.error}
                    helperText={fieldState?.error?.message}
                    startAdornment={
                      <InputAdornment position='start'>
                        <LockIcon />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position='end'>
                        <VisibilityToggle
                          visible={showNewPassword}
                          onClick={() => setShowNewPassword((prev) => !prev)}
                        />
                      </InputAdornment>
                    }
                  />
                )}
              />
              <Controller
                name='confirmPassword'
                control={control}
                rules={{
                  required: 'Please confirm your new password',
                  validate: (value) =>
                    value === watch('newPassword') || 'Passwords do not match',
                }}
                render={({ field, fieldState }) => (
                  <TextInputField
                    {...field}
                    label='Confirm Password'
                    placeholder='Re-enter new password'
                    type={showConfirmPassword ? 'text' : 'password'}
                    className='text-field'
                    error={!!fieldState.error}
                    helperText={fieldState?.error?.message}
                    startAdornment={
                      <InputAdornment position='start'>
                        <LockIcon />
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position='end'>
                        <VisibilityToggle
                          visible={showConfirmPassword}
                          onClick={() =>
                            setShowConfirmPassword((prev) => !prev)
                          }
                        />
                      </InputAdornment>
                    }
                  />
                )}
              />
              <CustomButton
                variant='contained'
                type='submit'
                fullwidth={true}
                size='large'
                className='reset-button'
                loading={loading}
                text={'Reset Password'}
              />
              {/* <Button
                variant='contained'
                type='submit'
                fullWidth
                className="reset-button"
              >
                Change Password
              </Button> */}
            </form>

            <Button
              variant='text'
              fullWidth
              className='back-to-login'
              onClick={() => navigate(LOGIN)}
            >
              Back to Login
            </Button>
          </CardContent>
        </Card>
      </Box>
    </>
  );
}

function VisibilityToggle({ visible, onClick }) {
  return (
    <IconButton onClick={onClick} edge='end'>
      {visible ? <Visibility /> : <VisibilityOff />}
    </IconButton>
  );
}
